/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationCrossPlayHandlersQuestEventDto } from './FxIdApplicationCrossPlayHandlersQuestEventDto';
import {
    FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON,
    FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSONTyped,
    FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON,
    FxIdApplicationCrossPlayHandlersQuestEventDtoToJSONTyped,
} from './FxIdApplicationCrossPlayHandlersQuestEventDto';
import type { FxIdDomainCrossPlayQuestTargetType } from './FxIdDomainCrossPlayQuestTargetType';
import {
    FxIdDomainCrossPlayQuestTargetTypeFromJSON,
    FxIdDomainCrossPlayQuestTargetTypeFromJSONTyped,
    FxIdDomainCrossPlayQuestTargetTypeToJSON,
    FxIdDomainCrossPlayQuestTargetTypeToJSONTyped,
} from './FxIdDomainCrossPlayQuestTargetType';
import type { FxIdApplicationCrossPlayHandlersUserQuestDtoProgress } from './FxIdApplicationCrossPlayHandlersUserQuestDtoProgress';
import {
    FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON,
    FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSONTyped,
    FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON,
    FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSONTyped,
} from './FxIdApplicationCrossPlayHandlersUserQuestDtoProgress';
import type { FxIdDomainCrossPlayQuestDependencyType } from './FxIdDomainCrossPlayQuestDependencyType';
import {
    FxIdDomainCrossPlayQuestDependencyTypeFromJSON,
    FxIdDomainCrossPlayQuestDependencyTypeFromJSONTyped,
    FxIdDomainCrossPlayQuestDependencyTypeToJSON,
    FxIdDomainCrossPlayQuestDependencyTypeToJSONTyped,
} from './FxIdDomainCrossPlayQuestDependencyType';

/**
 * 
 * @export
 * @interface FxIdApplicationCrossPlayHandlersUserQuestDto
 */
export interface FxIdApplicationCrossPlayHandlersUserQuestDto {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    Id: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    DependentQuestId?: number | null;
    /**
     * 
     * @type {FxIdDomainCrossPlayQuestDependencyType}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    DependencyType: FxIdDomainCrossPlayQuestDependencyType;
    /**
     * 
     * @type {FxIdDomainCrossPlayQuestTargetType}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    TargetType: FxIdDomainCrossPlayQuestTargetType;
    /**
     * 
     * @type {FxIdApplicationCrossPlayHandlersQuestEventDto}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    Event: FxIdApplicationCrossPlayHandlersQuestEventDto;
    /**
     * 
     * @type {FxIdApplicationCrossPlayHandlersUserQuestDtoProgress}
     * @memberof FxIdApplicationCrossPlayHandlersUserQuestDto
     */
    Progress?: FxIdApplicationCrossPlayHandlersUserQuestDtoProgress | null;
}



/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersUserQuestDto interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersUserQuestDto(value: object): value is FxIdApplicationCrossPlayHandlersUserQuestDto {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('DependencyType' in value) || value['DependencyType'] === undefined) return false;
    if (!('TargetType' in value) || value['TargetType'] === undefined) return false;
    if (!('Event' in value) || value['Event'] === undefined) return false;
    return true;
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON(json: any): FxIdApplicationCrossPlayHandlersUserQuestDto {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationCrossPlayHandlersUserQuestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'DependentQuestId': json['DependentQuestId'] == null ? undefined : json['DependentQuestId'],
        'DependencyType': FxIdDomainCrossPlayQuestDependencyTypeFromJSON(json['DependencyType']),
        'TargetType': FxIdDomainCrossPlayQuestTargetTypeFromJSON(json['TargetType']),
        'Event': FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON(json['Event']),
        'Progress': json['Progress'] == null ? undefined : FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON(json['Progress']),
    };
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoToJSON(json: any): FxIdApplicationCrossPlayHandlersUserQuestDto {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoToJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersUserQuestDtoToJSONTyped(value?: FxIdApplicationCrossPlayHandlersUserQuestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'DependentQuestId': value['DependentQuestId'],
        'DependencyType': FxIdDomainCrossPlayQuestDependencyTypeToJSON(value['DependencyType']),
        'TargetType': FxIdDomainCrossPlayQuestTargetTypeToJSON(value['TargetType']),
        'Event': FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON(value['Event']),
        'Progress': FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON(value['Progress']),
    };
}

